import { Flex, Tabs, Typography } from 'antd';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { useInvitations } from '../../api/Invitations';
import { useOrganization, useUsers } from '../../api/Onboarding';
import BackButton from '../../components/BackButton';
import InviteButton from '../../components/InviteButton';
import InviteMemberModal from '../../components/InviteMemberModal';
import Loading from '../../components/Loading';
import { SettingsPageTabs, UserRoleType } from '../../constants';
import InvitationsTab from './InvitationsTab';
import UsersTab from './UsersTab';

const { Title } = Typography;

const StyledDiv = styled.div`
  padding: 0 24px 24px;
`;

function Settings() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(SettingsPageTabs.USERS);
  const [showInviteModal, setShowInviteModal] = useState(false);

  const { data: organization, isLoading: organizationLoading } = useOrganization();
  const { data: users, isLoading: usersLoading } = useUsers(
    { organizationId: organization?.data.id },
    {
      enabled: !!organization?.data.id,
      select: (data) => ({
        ...data,
        data: data.data.filter((u) => u.role !== UserRoleType.CLIENT),
      }),
    },
  );
  const { data: invitations, isLoading: invitationsLoading } = useInvitations({
    select: (data) => ({
      ...data,
      data: data.data.filter((i) => i.role !== UserRoleType.CLIENT),
    }),
  });

  const toggleInviteModal = () => {
    setShowInviteModal(!showInviteModal);
  };

  const tabData = [
    {
      key: SettingsPageTabs.USERS,
      label: SettingsPageTabs.USERS,
    },
    {
      key: SettingsPageTabs.INVITATIONS,
      label: SettingsPageTabs.INVITATIONS,
    },
  ];

  if (organizationLoading || usersLoading || invitationsLoading) {
    return <Loading />;
  }

  return (
    <StyledDiv>
      <BackButton onClick={() => navigate(-1)} text="Back" />
      <Flex vertical gap={16}>
        <Title level={4}>Settings</Title>
        <Tabs
          activeKey={activeTab}
          onChange={setActiveTab}
          items={tabData}
          tabBarExtraContent={<InviteButton onClick={toggleInviteModal} />}
        />
        {activeTab === SettingsPageTabs.USERS && (
          <UsersTab users={users} organizationId={organization.data.id} />
        )}
        {activeTab === SettingsPageTabs.INVITATIONS && <InvitationsTab invitations={invitations} />}
      </Flex>
      <InviteMemberModal closeModal={toggleInviteModal} visible={showInviteModal} />
    </StyledDiv>
  );
}

export default Settings;
